export var pxToRem = function pxToRem(px) {
  if (typeof px === 'string') {
    px = px.replace('px', '');
  }
  return "".concat(px / 16, "rem");
};
export function setCssVar(prop, value) {
  return "".concat(prop["private"], ": var(").concat(prop["public"], ", ").concat(value, ");");
}